
























import { reportSourceType } from '@/utilities/test-helpers.js'
import { Component, Vue, Prop } from 'vue-property-decorator'
import Modal from '@/components/Modal/Modal.vue'
import ModalContent from '@/components/Modal/ModalContent.vue'
import ModalHeader from '@/components/Modal/ModalHeader.vue'
import ModalFooter from '@/components/Modal/ModalFooter.vue'
import { Button } from '@alpha/ink'
import $ from 'jquery'
import bootstrap from 'bootstrap' // This only exists to allow for .modal('show') TODO Migrate away from bootstrap
import analytics from '@/analytics'

export interface Window {
  [key:string]: any; // Add index signature
}

@Component({
  components: {
    Modal,
    ModalContent,
    ModalHeader,
    ModalFooter,
    Button
  }
})
export default class SharedReportModal extends Vue {
  @Prop() viewurl!:any
  @Prop() header!:any
  @Prop() report!:any

  window: Window = window

  updated () {
    if (this.viewurl) {
      var thisModal = this.$refs.modal
      $(thisModal).modal('show') // TODO:BOOTSTRAP - MIGRATE
    }
  }

  bootstrap () {
    return bootstrap // TODO:BOOTSTRAP - MIGRATE
  }

  mounted () {
    var thisModal = this.$refs.modal
    var that = this
    // Keep state in sync with modal
    $(thisModal).on('hidden.bs.modal', function () {
      that.$emit('close')
    })
    $(document).on('keyup', function (e:any) {
      switch (e.which) {
        case 27: // esc
          {
            const $$:any = $
            $$(thisModal).modal('hide') // TODO:BOOTSTRAP - MIGRATE
          }
          break
        default:
      }
    })
  }

  copyLink () {
    var sourceId = this.report.config ? this.report.config.id : this.report.client.viewId
    analytics.track('Shared Report Url Copied From Report Builder', {
      sourceId: sourceId,
      sourceType: reportSourceType(this.report)
    })

    var link = this.$refs.link
    var linkContainer = this.$refs.linkContainer
    $(linkContainer).toggleClass('hidden')
    this.window.getSelection().removeAllRanges()
    var range = document.createRange()
    range.selectNode(link as Node)
    this.window.getSelection().addRange(range)
    try {
      var success = document.execCommand('copy')
      if (success) {
        this.flashMessage('Copied sharing link to clipboard.')
      } else {
        console.error('Couldnt copy')
      }
    } catch (err) {
      console.error('Oops, couldnt copy', err)
    }
    $(link).toggleClass('hidden')
    this.window.getSelection().removeAllRanges()
  }

  flashMessage (message:any) {
    var $response = $('#ajax-response')
    $response
      .text(message)
      .fadeIn(200)
    setTimeout(function () {
      $response.fadeOut(500)
    }, 1500)
  }

  viewReport () {
    window.open(this.viewurl, '_blank')
  }

  close () {
    this.$emit('close')
  }
}
